export enum StatusDesc {
  Pending = 'Pending',
  PendingRequestedInformation = 'Pending (requested additional information)',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Withdrawn = 'Withdrawn',
  Revoke = 'Revoke',
};
